import { render } from "./NewCalculation.vue?vue&type=template&id=6ac58050"
import script from "./NewCalculation.vue?vue&type=script&lang=ts"
export * from "./NewCalculation.vue?vue&type=script&lang=ts"
script.render = render

export default script